import { Button, Modal } from "antd";
import './thank-you.scss'
import { CheckCircleOutlined } from "@ant-design/icons";
import parse from "html-react-parser";


export default function Thankyou({ form, setUploadedCvURL, setFileList, openThankYou, setOpenThankYou, thankyouContent }) {
    const handleClose = () => {
        form.resetFields();
        setUploadedCvURL(null);
        setFileList([]);
        setOpenThankYou(false);
    }

    return (
        <Modal
            open={openThankYou}
            footer={null}
            onCancel={handleClose}
        >
            <div className="thank-you-container">
                <CheckCircleOutlined className="icon-success" />
                <div className="middle-content">
                    {thankyouContent ? (parse(thankyouContent)) : (
                        <>
                            <p className="thankyou-heading">Thank you for your application.</p>
                            <p className="thankyou-email">You will receive an email soon.</p>
                        </>
                    )}
                    
                </div>
                <Button onClick={handleClose}>Close</Button>
            </div>
        </Modal>
    )
}